module.exports = __webpack_public_path__ + "img/sintesis1.e0f6c7e8.png";